var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"home-link-card",attrs:{"href":_vm.card.link,"target":"_blank"}},[_c('div',{staticClass:"home-link-card-logo",style:({'background':_vm.card.logoColor})},[_c('img',{attrs:{"src":_vm.card.img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"home-link-card-title"},[_vm._v("\n    "+_vm._s(this.$t(_vm.card.name))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a41b44a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homeLinkCard.vue
// module id = null
// module chunks = 